// extracted by mini-css-extract-plugin
export default {"networkProfilePicture":"channel_networkProfilePicture__MYPbJ"};